import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.chatbot.component.chatbot');
import { OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-chatbot-component-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.chatbot.component.chatbot/view.scss */
.chatbot-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4A6FD8, #6C5CE7);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(74, 111, 216, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
}
.chatbot-fab:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 24px rgba(74, 111, 216, 0.5);
}
.chatbot-fab:active {
  transform: scale(0.96);
}

.chatbot-side-panel {
  position: relative;
  height: 100%;
  min-width: 500px;
  max-width: 900px;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  background: white;
  border-left: none;
}

.chatbot-resize-handle {
  position: absolute;
  left: -7px;
  top: 0;
  width: 14px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chatbot-resize-handle:hover .chatbot-resize-grip, .chatbot-resize-handle:active .chatbot-resize-grip {
  background: linear-gradient(180deg, #e8e5fb 0%, #dbd5f7 100%);
  border-color: #6c5ce7;
  box-shadow: 0 1px 6px rgba(108, 92, 231, 0.3);
}
.chatbot-resize-handle:hover, .chatbot-resize-handle:active {
  background: transparent;
}

.chatbot-resize-grip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 14px;
  height: 64px;
  border-radius: 7px;
  border: 1px solid #b8aef0;
  background: linear-gradient(180deg, #f0eeff 0%, #e8e5fb 100%);
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}
.chatbot-resize-grip span {
  display: block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #8b7fd4;
}

.chatbot-panel-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;
}

.chatbot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(135deg, #4A6FD8, #6C5CE7);
  color: white;
  flex-shrink: 0;
}

.chatbot-clear-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);
}

.chatbot-clear-modal {
  width: min(360px, 100vw - 32px);
  border-radius: 8px;
  border: 1px solid #fee2e2;
  background: #fff;
  padding: 20px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.22);
}

.chatbot-clear-modal-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc2626;
  background: #fef2f2;
  margin-bottom: 12px;
}

.chatbot-clear-modal-title {
  margin: 0;
  color: #111827;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.chatbot-clear-modal-copy {
  margin: 6px 0 18px;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.55;
}

.chatbot-clear-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.chatbot-clear-modal-cancel,
.chatbot-clear-modal-confirm {
  min-width: 64px;
  height: 34px;
  border-radius: 6px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.15s, border-color 0.15s, color 0.15s, opacity 0.15s;
}
.chatbot-clear-modal-cancel:disabled,
.chatbot-clear-modal-confirm:disabled {
  opacity: 0.65;
  cursor: default;
}

.chatbot-clear-modal-cancel {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
}
.chatbot-clear-modal-cancel:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}

.chatbot-clear-modal-confirm {
  border: 1px solid #dc2626;
  background: #dc2626;
  color: #fff;
}
.chatbot-clear-modal-confirm:hover:not(:disabled) {
  background: #b91c1c;
  border-color: #b91c1c;
}

.chatbot-messages {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 0;
}
.chatbot-messages::-webkit-scrollbar {
  width: 4px;
}
.chatbot-messages::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}

.chatbot-weights {
  flex-shrink: 0;
  max-height: min(46vh, 340px);
  overflow-y: auto;
  padding: 8px 12px;
  border-top: 1px solid #dbe3f0;
  border-bottom: 1px solid #eef2f7;
  background: #fff;
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.04);
}
.chatbot-weights::-webkit-scrollbar {
  width: 4px;
}
.chatbot-weights::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.chatbot-weights--collapsed {
  max-height: none;
  overflow: visible;
}

.chatbot-weights-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.chatbot-weights-title {
  color: #18181b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.chatbot-weights-toggle {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #4A6FD8;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.chatbot-weights-toggle:hover {
  background: #eef2ff;
  color: #2C4A99;
}

.chatbot-weight-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chatbot-internal-weights {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chatbot-weight-group-label {
  margin-top: 2px;
  color: #4A6FD8;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.3;
}

.chatbot-weight-divider {
  height: 1px;
  margin: 2px 0;
  background: #edf1f7;
}

.chatbot-weight-ratio {
  display: flex;
  justify-content: center;
  gap: 10px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.3;
}
.chatbot-weight-ratio span:first-child {
  color: #4A6FD8;
  font-weight: 700;
}
.chatbot-weight-ratio span:last-child {
  color: #15803d;
  font-weight: 700;
}

.chatbot-weight-row {
  display: grid;
  grid-template-columns: minmax(150px, 190px) minmax(0, 1fr) 46px;
  align-items: center;
  gap: 8px;
}

.chatbot-weight-row--ratio {
  grid-template-columns: 72px minmax(0, 1fr) 42px;
}
.chatbot-weight-row--ratio .chatbot-weight-label {
  gap: 0;
}

.chatbot-weight-grid {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.chatbot-weight-grid .chatbot-weight-row {
  grid-template-columns: minmax(150px, 190px) minmax(0, 1fr) 46px;
}

.chatbot-weight-label {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #52525b;
  line-height: 1.25;
  word-break: keep-all;
}

.chatbot-weight-label-main {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.chatbot-weight-label-title {
  font-size: 11px;
  font-weight: 500;
  color: #52525b;
}

.chatbot-weight-help {
  position: relative;
  flex: 0 0 auto;
  width: 15px;
  height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 50%;
  background: #fff;
  color: #64748b;
  cursor: help;
  line-height: 1;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.chatbot-weight-help:hover, .chatbot-weight-help:focus-visible {
  background: #eef2ff;
  border-color: #93a7e8;
  color: #4A6FD8;
  outline: none;
}
.chatbot-weight-help:hover .chatbot-weight-tooltip, .chatbot-weight-help:focus-visible .chatbot-weight-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%);
}

.chatbot-weight-help-mark {
  font-size: 10px;
  font-weight: 700;
}

.chatbot-weight-tooltip {
  position: absolute;
  left: calc(100% + 7px);
  top: 50%;
  z-index: 30;
  width: max-content;
  max-width: 220px;
  padding: 6px 8px;
  border-radius: 6px;
  background: #111827;
  color: #fff;
  font-size: 10.5px;
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
  word-break: keep-all;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(-2px, -50%);
  transition: opacity 0.12s ease, visibility 0.12s ease, transform 0.12s ease;
}

.chatbot-weight-tooltip::before {
  content: "";
  position: absolute;
  left: -4px;
  top: 50%;
  width: 8px;
  height: 8px;
  background: #111827;
  transform: translateY(-50%) rotate(45deg);
}

.chatbot-weight-range {
  --range-start: #DCE6FF;
  --range-end: #4A6FD8;
  --range-accent: #4A6FD8;
  --range-percent: 50%;
  width: 100%;
  min-width: 0;
  height: 4px;
  border-radius: 999px;
  -webkit-appearance: none;
  appearance: none;
  accent-color: var(--range-accent);
  background: linear-gradient(90deg, var(--range-start) 0%, var(--range-end) var(--range-percent), #dfe5f2 var(--range-percent), #dfe5f2 100%);
  cursor: pointer;
}

.chatbot-weight-range:focus-visible {
  outline: 2px solid rgba(74, 111, 216, 0.28);
  outline-offset: 4px;
}

.chatbot-weight-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: transparent;
}

.chatbot-weight-range::-webkit-slider-thumb {
  width: 14px;
  height: 14px;
  margin-top: -5px;
  border: 2px solid #fff;
  border-radius: 50%;
  -webkit-appearance: none;
  appearance: none;
  background: var(--range-accent);
  box-shadow: 0 1px 4px rgba(44, 74, 153, 0.28);
}

.chatbot-weight-range::-moz-range-track {
  height: 4px;
  border-radius: 999px;
  background: #dfe5f2;
}

.chatbot-weight-range::-moz-range-progress {
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--range-start), var(--range-end));
}

.chatbot-weight-range::-moz-range-thumb {
  width: 10px;
  height: 10px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: var(--range-accent);
  box-shadow: 0 1px 4px rgba(44, 74, 153, 0.28);
}

.chatbot-weight-value {
  min-width: 44px;
  color: #4A6FD8;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  text-align: right;
}

.chatbot-weights-note {
  margin-top: 8px;
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 10px;
  line-height: 1.35;
}
.chatbot-weights-note p {
  margin: 0;
}
.chatbot-weights-note p + p {
  margin-top: 2px;
}

.chatbot-page-context {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-top: 1px solid #f3f4f6;
  background: #fafbfc;
  flex-shrink: 0;
}

.chatbot-input {
  flex-shrink: 0;
  padding: 10px 12px;
  border-top: 1px solid #e5e7eb;
  background: white;
}

.agent-spinner {
  animation: agent-spin 2s linear infinite;
}

@keyframes agent-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.streaming-dots {
  display: inline-flex;
  gap: 0;
}
.streaming-dots span {
  animation: streaming-dot-blink 1.4s infinite;
  opacity: 0;
}
.streaming-dots span:nth-child(1) {
  animation-delay: 0s;
}
.streaming-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.streaming-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes streaming-dot-blink {
  0%, 20% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  60%, 100% {
    opacity: 0;
  }
}
.agent-pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #7C3AED;
  position: relative;
}
.agent-pulse::after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid #7C3AED;
  animation: agent-pulse-ring 1.2s ease-in-out infinite;
}

@keyframes agent-pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.6);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.chatbot-status-card {
  border: 1px solid #e9e7ff;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(180deg, #fcfbff 0%, #f7f5ff 100%);
  box-shadow: 0 8px 18px rgba(91, 33, 182, 0.05);
}

.chatbot-status-card--active {
  border-color: #d8ccff;
}

.chatbot-status-card--done {
  background: linear-gradient(180deg, #ffffff 0%, #faf8ff 100%);
}

.chatbot-status-card--error {
  border-color: #fcd34d;
  background: linear-gradient(180deg, #fffdf7 0%, #fff8e8 100%);
}

.chatbot-status-card--cancelled {
  border-color: #e5e7eb;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.chatbot-status-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
}

.chatbot-status-card-main {
  flex: 1;
  min-width: 0;
}

.chatbot-status-card-topline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
}

.chatbot-status-stage {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  color: #312e81;
}

.chatbot-status-copy {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.55;
  color: #615b75;
}

.chatbot-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10px;
  line-height: 1.3;
  font-weight: 700;
}

.chatbot-status-badge--live {
  color: #7c3aed;
  background: #ede9fe;
}

.chatbot-status-badge--done {
  color: #047857;
  background: #d1fae5;
}

.chatbot-status-badge--error {
  color: #b45309;
  background: #fef3c7;
}

.chatbot-status-badge--cancelled {
  color: #475569;
  background: #e2e8f0;
}

.chatbot-status-toggle {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
  padding: 4px 8px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: #6d28d9;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.chatbot-status-toggle:hover {
  background: #ede9fe;
}

.chatbot-status-keywords {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0 12px 10px;
}

.chatbot-steps-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
}
.chatbot-steps-header:hover {
  background: #f0f1f3;
}

.chatbot-steps-header--active {
  cursor: default;
  background: #f3f0ff;
  border-bottom: 1px solid #e8e5f5;
}
.chatbot-steps-header--active:hover {
  background: #f3f0ff;
}

.chatbot-steps-list {
  border-top: 1px solid #e8e9eb;
}

.chatbot-steps-list--embedded {
  border-top-color: #ece8ff;
}

.chatbot-step-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 12px;
  border-bottom: 1px solid #f0f1f3;
  transition: background 0.15s;
}
.chatbot-step-item:last-child {
  border-bottom: none;
}

.chatbot-step-item--active {
  background: #faf8ff;
}

.chatbot-step-item--done {
  background: transparent;
}

.chatbot-step-item--error {
  background: #fffbeb;
}

.chatbot-step-indicator {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.chatbot-step-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #e0d4f5;
  border-top-color: #7C3AED;
  border-radius: 50%;
  animation: step-spin 0.7s linear infinite;
}

@keyframes step-spin {
  to {
    transform: rotate(360deg);
  }
}
.chatbot-step-content {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.chatbot-step-text {
  font-size: 11.5px;
  color: #37352f;
  font-weight: 500;
  line-height: 1.4;
}

.chatbot-step-item--done .chatbot-step-text {
  color: #8b8b89;
  font-weight: 400;
}

.chatbot-step-item--active .chatbot-step-text {
  color: #5b21b6;
  font-weight: 500;
}

.chatbot-step-summary {
  font-size: 10.5px;
  color: #a0a09e;
  line-height: 1.3;
}

.chatbot-generating-shell {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.chatbot-generating-avatar {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6d28d9;
  background: linear-gradient(135deg, #ede9fe 0%, #f5f3ff 100%);
  border: 1px solid #ddd6fe;
  box-shadow: 0 4px 12px rgba(109, 40, 217, 0.12);
}

.chatbot-generating-card {
  max-width: 88%;
  padding: 12px 14px;
  border-radius: 18px;
  border-top-left-radius: 6px;
  border: 1px solid #e9e7ff;
  background: linear-gradient(180deg, #ffffff 0%, #f7f5ff 100%);
  box-shadow: 0 10px 24px rgba(91, 33, 182, 0.08);
}

.chatbot-generating-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
}

.chatbot-generating-title {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  color: #312e81;
}

.chatbot-generating-stop {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  line-height: 1.3;
  font-weight: 700;
  color: #be123c;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 999px;
  padding: 2px 6px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.chatbot-generating-stop:hover {
  color: #9f1239;
  background: #ffe4e6;
  border-color: #fda4af;
}

.chatbot-generating-copy {
  margin: 0;
  font-size: 11px;
  line-height: 1.6;
  color: #6b667e;
}

.chatbot-generating-dots {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}
.chatbot-generating-dots span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #8b5cf6;
  animation: chatbot-generating-dot 1.1s ease-in-out infinite;
}
.chatbot-generating-dots span:nth-child(1) {
  animation-delay: 0s;
}
.chatbot-generating-dots span:nth-child(2) {
  animation-delay: 0.15s;
}
.chatbot-generating-dots span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes chatbot-generating-dot {
  0%, 100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
.agent-pulse-sm {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7C3AED;
  position: relative;
}
.agent-pulse-sm::after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 1.5px solid #7C3AED;
  animation: agent-pulse-ring 1.2s ease-in-out infinite;
}

@keyframes cursor-blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
:host ::ng-deep .chatbot-md.is-streaming > *:last-child::after {
  content: "";
  display: inline-block;
  width: 2px;
  height: 13px;
  background: #37352f;
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: cursor-blink 0.8s steps(2) infinite;
}
:host ::ng-deep .chatbot-md {
  line-height: 1.65;
  word-break: break-word;
  color: #37352f;
  font-size: 13px;
}
:host ::ng-deep .chatbot-md > *:first-child {
  margin-top: 0;
}
:host ::ng-deep .chatbot-md > *:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .chatbot-md h1, :host ::ng-deep .chatbot-md h2, :host ::ng-deep .chatbot-md h3, :host ::ng-deep .chatbot-md h4 {
  color: #1a1a1a;
  font-weight: 600;
  line-height: 1.35;
}
:host ::ng-deep .chatbot-md h1 {
  font-size: 15px;
  margin: 18px 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #f0efed;
}
:host ::ng-deep .chatbot-md h2 {
  font-size: 14px;
  margin: 14px 0 6px;
}
:host ::ng-deep .chatbot-md h3 {
  font-size: 13px;
  font-weight: 600;
  margin: 10px 0 4px;
}
:host ::ng-deep .chatbot-md p {
  margin: 4px 0;
}
:host ::ng-deep .chatbot-md strong {
  font-weight: 600;
  color: #1a1a1a;
}
:host ::ng-deep .chatbot-md em {
  font-style: italic;
}
:host ::ng-deep .chatbot-md ul, :host ::ng-deep .chatbot-md ol {
  margin: 6px 0;
  padding-left: 22px;
}
:host ::ng-deep .chatbot-md ul {
  list-style: disc;
}
:host ::ng-deep .chatbot-md ul li::marker {
  color: #b4b4b0;
}
:host ::ng-deep .chatbot-md ol {
  list-style: decimal;
}
:host ::ng-deep .chatbot-md ol li::marker {
  color: #787774;
  font-size: 13px;
}
:host ::ng-deep .chatbot-md li {
  margin: 2px 0;
  padding-left: 2px;
}
:host ::ng-deep .chatbot-md li ul, :host ::ng-deep .chatbot-md li ol {
  margin: 2px 0;
}
:host ::ng-deep .chatbot-md code {
  background: rgba(135, 131, 120, 0.12);
  padding: 1.5px 5px;
  border-radius: 4px;
  font-size: 85%;
  font-family: "SFMono-Regular", Menlo, Consolas, monospace;
  color: #c7254e;
}
:host ::ng-deep .chatbot-md pre {
  background: #fafaf9;
  border: 1px solid #eeeeed;
  padding: 12px 16px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 8px 0;
  font-size: 12px;
  line-height: 1.55;
}
:host ::ng-deep .chatbot-md pre code {
  background: none;
  padding: 0;
  color: #37352f;
  font-size: inherit;
  border-radius: 0;
}
:host ::ng-deep .chatbot-md blockquote {
  border-left: 3px solid #d8d7d4;
  padding: 3px 0 3px 14px;
  margin: 8px 0;
  color: #6b6b68;
}
:host ::ng-deep .chatbot-md blockquote p {
  margin: 2px 0;
}
:host ::ng-deep .chatbot-md .table-scroll-wrapper {
  overflow-x: auto;
  margin: 10px 0;
  border-radius: 8px;
  border: 1px solid #e8e7e4;
}
:host ::ng-deep .chatbot-md .table-scroll-wrapper::-webkit-scrollbar {
  height: 5px;
}
:host ::ng-deep .chatbot-md .table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #d1d0cc;
  border-radius: 3px;
}
:host ::ng-deep .chatbot-md table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12.5px;
  border-spacing: 0;
}
:host ::ng-deep .chatbot-md table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
:host ::ng-deep .chatbot-md table th {
  background: #f8f8f7;
  font-weight: 600;
  color: #4a4a47;
  font-size: 11.5px;
  padding: 8px 12px;
  text-align: left;
  border-bottom: 2px solid #e8e7e4;
  white-space: nowrap;
}
:host ::ng-deep .chatbot-md table td {
  padding: 7px 12px;
  color: #37352f;
  border-bottom: 1px solid #f0efed;
  vertical-align: top;
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
}
:host ::ng-deep .chatbot-md table th:first-child,
:host ::ng-deep .chatbot-md table td:first-child {
  text-align: center;
}
:host ::ng-deep .chatbot-md table tbody tr {
  transition: background 0.1s ease;
}
:host ::ng-deep .chatbot-md table tbody tr:hover td {
  background: #fafaf9;
}
:host ::ng-deep .chatbot-md table tbody tr:last-child td {
  border-bottom: none;
}
:host ::ng-deep .chatbot-md hr {
  border: none;
  height: 1px;
  background: #eeeeed;
  margin: 14px 0;
}
:host ::ng-deep .chatbot-md a {
  color: #4A6FD8;
  text-decoration: none;
}
:host ::ng-deep .chatbot-md a:hover {
  text-decoration: underline;
}
:host ::ng-deep .chatbot-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 10px;
  background: #f9f9f8;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #eeeeed;
}
:host ::ng-deep .chatbot-intent-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #4A6FD8;
  white-space: nowrap;
}
:host ::ng-deep .chatbot-meta-sep {
  width: 1px;
  height: 12px;
  background: #d8d7d4;
  flex-shrink: 0;
}
:host ::ng-deep .chatbot-keywords-wrap {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
:host ::ng-deep .chatbot-keyword-tag {
  font-size: 10.5px;
  color: #555;
  background: white;
  padding: 1px 7px;
  border-radius: 4px;
  border: 1px solid #e8e7e4;
  white-space: nowrap;
}
:host ::ng-deep .chatbot-keyword-more {
  font-size: 10px;
  color: #787774;
}
:host ::ng-deep .chatbot-html-block {
  margin: 8px 0;
  border: 1px solid #e8e7e4;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  position: relative;
}
:host ::ng-deep .chatbot-html-block:hover .chatbot-html-block-toolbar {
  opacity: 1;
}
:host ::ng-deep .chatbot-html-block iframe {
  display: block;
  width: 100%;
  border: none;
  min-height: 60px;
}
:host ::ng-deep .chatbot-html-block-toolbar {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.15s ease;
  display: flex;
  gap: 4px;
}
:host ::ng-deep .chatbot-html-block-toolbar button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.95);
  color: #6b7280;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.15s ease;
  padding: 0;
}
:host ::ng-deep .chatbot-html-block-toolbar button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #d1d5db;
}
:host ::ng-deep .chatbot-charts {
  font-size: 13px;
}
:host ::ng-deep .chart-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
  margin-top: 12px;
}
:host ::ng-deep .chart-section-title:first-child {
  margin-top: 0;
}
:host ::ng-deep .inline-chart {
  margin: 8px 0;
  padding: 12px 14px;
  border: 1px solid #e8e7e4;
  border-radius: 8px;
  background: #fdfcfb;
}
:host ::ng-deep .bar-chart .chart-bar-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
:host ::ng-deep .bar-chart .chart-bar-item:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .bar-chart .chart-bar-label {
  font-size: 11px;
  color: #6b6b68;
  min-width: 44px;
  max-width: 90px;
  text-align: right;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .bar-chart .chart-bar-track {
  flex: 1;
  height: 16px;
  background: #f0efed;
  border-radius: 4px;
  overflow: hidden;
}
:host ::ng-deep .bar-chart .chart-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #4A6FD8, #6B8DE8);
  border-radius: 4px;
  transition: width 0.5s ease;
  min-width: 2px;
}
:host ::ng-deep .bar-chart .chart-bar-value {
  font-size: 11px;
  color: #37352f;
  font-weight: 600;
  width: 30px;
  text-align: right;
  flex-shrink: 0;
}
:host ::ng-deep .donut-chart {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
:host ::ng-deep .donut-chart .donut-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: white;
  border: 1px solid #f0efed;
  border-radius: 6px;
}
:host ::ng-deep .donut-chart .donut-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
:host ::ng-deep .donut-chart .donut-label {
  font-size: 11px;
  color: #37352f;
  font-weight: 500;
}
:host ::ng-deep .donut-chart .donut-value {
  font-size: 11px;
  color: #787774;
}`],
})
export class PortalChatbotComponentChatbotComponent implements OnInit, OnDestroy {
    private static AGENT_SUMMARY_KEY = 'agent_recommendation_summary';
    private static AGENT_RESEARCHERS_KEY = 'agent_recommended_researchers';
    private static AGENT_QUERY_KEY = 'agent_recommendation_query';
    public isOpen: boolean = false;
    public messages: any[] = [];
    public input: string = '';
    public loading: boolean = false;
    public enabled: boolean = true;
    public showWeights: boolean = true;
    public clearConfirmOpen: boolean = false;
    public clearConfirmBusy: boolean = false;
    public panelWidth: number = 560;

    // 현재 페이지 컨텍스트
    public currentPageLabel: string = '';
    public currentPageContext: any = {};

    // 시각화 결과 식별자 생성용 카운터
    private hasVisualization: boolean = false;
    private visualizationCounter: number = 0;

    // DB 세션 관리
    public currentSessionId: string = '';
    private saveTimer: any = null;

    // 예시 질문
    public suggestions: any[] = [];

    private resizing: boolean = false;
    private resizeListener: any;
    private resizeEndListener: any;
    private resizeRaf: number = 0;
    private routerSub: Subscription | null = null;
    private forceCloseHandler: any;
    private activeAbortController: AbortController | null = null;
    private activeAssistantMsg: any = null;
    private generationStopRequested: boolean = false;

    private static STORAGE_KEY = 'wiz-chatbot-messages';

    public weights: any = {
        paper_count_weight: 0.25,
        report_count_weight: 0.15,
        recent_count_weight: 0.25,
        patent_count_weight: 0.15,
        focus_score_weight: 0.20,
        publication_score_weight: 0.25,
        journal_level_score_weight: 0.15,
    };

    constructor(@Inject( Service)         public service: Service,@Inject( Renderer2)         private renderer: Renderer2,@Inject( Router)         private router: Router,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    public async ngOnInit() {
        await this.service.init();
        try {
            const { code, data } = await wiz.call("is_enabled");
            if (code === 200) {
                this.enabled = data.enabled !== false;
            }
        } catch (e) { }

        this.updatePageContext();
        // 새로고침/세션 종료 뒤에는 채팅과 시각화가 복구되지 않도록 영속 데이터를 비운다.
        this.messages = [];
        this.currentSessionId = '';
        try { localStorage.removeItem(Component.STORAGE_KEY); } catch {}
        this.loadSuggestions();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updatePageContext();
                this.loadSuggestions();
                await this.service.render();
            }
        });

        // 레이아웃에서 강제 닫기 이벤트 수신 (메인 페이지 복귀 시)
        this.forceCloseHandler = () => {
            if (this.isOpen) {
                this.isOpen = false;
                this.service.render();
            }
        };
        window.addEventListener('chatbot-force-close', this.forceCloseHandler);

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.activeAbortController) this.activeAbortController.abort();
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.forceCloseHandler) window.removeEventListener('chatbot-force-close', this.forceCloseHandler);
        this.removeResizeListeners();
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
    }

    // === 현재 페이지 컨텍스트 ===
    private updatePageContext() {
        const path = location.pathname;
        const params = new URLSearchParams(location.search);
        const ctx: any = { path };

        if (path === '/' || path === '') {
            ctx.type = 'home';
            this.currentPageLabel = '홈';
        } else if (path.startsWith('/search')) {
            ctx.type = 'search';
            ctx.tab = params.get('tab') || 'researcher';
            ctx.query = params.get('q') || '';
            const agentIds = (params.get('agent_ids') || '')
                .split(',')
                .map((id: string) => id.trim())
                .filter((id: string) => id);
            if (agentIds.length > 0) {
                ctx.agent_ids = agentIds;
            }
            const agentQuery = this.getStoredAgentQuery();
            if (agentQuery) {
                ctx.agent_query = agentQuery;
            }
            const agentSummary = this.getStoredAgentSummary();
            if (agentSummary) {
                ctx.agent_summary = agentSummary.slice(0, 500);
            }
            const agentResearchers = this.getStoredAgentResearchers();
            if (agentResearchers.length > 0) {
                ctx.agent_researchers = this.slimAgentResearchers(agentResearchers);
            }
            this.currentPageLabel = '전문가 검색';
        } else if (path.startsWith('/researcher/')) {
            const parts = path.split('/');
            ctx.type = 'researcher';
            ctx.researcher_id = parts[2] || '';
            ctx.tab = parts[3] || 'summary';
            this.currentPageLabel = '연구자 프로필';
        } else if (path.startsWith('/organization/')) {
            const parts = path.split('/');
            ctx.type = 'organization';
            ctx.organization_id = parts[2] || '';
            this.currentPageLabel = '기관 상세';
        } else if (path.startsWith('/admin')) {
            ctx.type = 'admin';
            this.currentPageLabel = '관리자';
        } else {
            ctx.type = 'other';
            this.currentPageLabel = path;
        }

        this.currentPageContext = ctx;
    }

    public async toggle() {
        this.isOpen = !this.isOpen;
        window.dispatchEvent(new CustomEvent('chatbot-panel-toggle', { detail: { open: this.isOpen } }));
        await this.service.render();
    }

    public async close() {
        this.isOpen = false;
        window.dispatchEvent(new CustomEvent('chatbot-panel-toggle', { detail: { open: false } }));
        await this.service.render();
    }

    public async toggleWeights() {
        this.showWeights = !this.showWeights;
        await this.service.render();
    }

    public async openWeights() {
        this.showWeights = true;
        await this.service.render();
    }

    public async closeWeights() {
        this.showWeights = false;
        await this.service.render();
    }

    public async onWeightChange(key: string, event: Event) {
        const val = parseInt((event.target as HTMLInputElement).value, 10);
        const value = this.clampWeight(val / 100, 0);
        this.weights[key] = value;
        await this.service.render();
    }

    private clampWeight(value: any, fallback: number = 0): number {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return fallback;
        return Math.min(1, Math.max(0, numeric));
    }

    public getWeightPercent(key: string): number {
        return this.clampWeight(this.weights[key], 0) * 100;
    }

    private getActiveWeights() {
        const defaults: any = {
            paper_count_weight: 0.25,
            report_count_weight: 0.15,
            recent_count_weight: 0.25,
            patent_count_weight: 0.15,
            focus_score_weight: 0.20,
            publication_score_weight: 0.25,
            journal_level_score_weight: 0.15,
        };
        const result: any = {};

        Object.keys(defaults).forEach((key) => {
            const raw = Number(this.weights[key]);
            const value = Number.isFinite(raw) && raw >= 0 ? raw : defaults[key];
            result[key] = Math.min(1, Math.max(0, value));
        });
        return result;
    }

    // === Resize Handle ===
    public onResizeStart(event: MouseEvent) {
        event.preventDefault();
        this.resizing = true;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';

        this.resizeListener = this.renderer.listen('document', 'mousemove', (e: MouseEvent) => {
            if (!this.resizing) return;
            const newWidth = window.innerWidth - e.clientX;
            this.panelWidth = Math.max(500, Math.min(newWidth, 900));
            if (!this.resizeRaf) {
                this.resizeRaf = requestAnimationFrame(() => {
                    this.resizeRaf = 0;
                    this.service.render();
                });
            }
        });

        this.resizeEndListener = this.renderer.listen('document', 'mouseup', async () => {
            this.resizing = false;
            if (this.resizeRaf) {
                cancelAnimationFrame(this.resizeRaf);
                this.resizeRaf = 0;
            }
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            this.removeResizeListeners();
            await this.service.render();
        });
    }

    private removeResizeListeners() {
        if (this.resizeListener) { this.resizeListener(); this.resizeListener = null; }
        if (this.resizeEndListener) { this.resizeEndListener(); this.resizeEndListener = null; }
    }

    // === 마크다운 렌더링 ===
    private mdConverter = new showdown.Converter({
        tables: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tasklists: true,
        openLinksInNewWindow: true,
        ghCodeBlocks: true,
    });

    public renderMarkdown(text: string): SafeHtml {
        if (!text) return this.sanitizer.bypassSecurityTrustHtml('');
        try {
            let html = this.mdConverter.makeHtml(text);
            // 테이블 스크롤 래퍼
            html = html.replace(/<table/g, '<div class="table-scroll-wrapper"><table');
            html = html.replace(/<\/table>/g, '</table></div>');
            // 차트 마커 처리 (폴백)
            html = this.processChartMarkers(html);
            return this.sanitizer.bypassSecurityTrustHtml(html);
        } catch (e) {
            return this.sanitizer.bypassSecurityTrustHtml(text.replace(/\n/g, '<br>'));
        }
    }

    private processChartMarkers(html: string): string {
        const chartRegex = /<!--chart:(bar|donut|line):(.*?)-->/gs;
        return html.replace(chartRegex, (match, type, jsonStr) => {
            try {
                const data = JSON.parse(jsonStr);
                return this.renderChart(type, data);
            } catch {
                return '';
            }
        });
    }

    private renderChart(type: string, data: any): string {
        if (type === 'bar') {
            return this.renderBarChart(data);
        } else if (type === 'donut') {
            return this.renderDonutChart(data);
        }
        return '';
    }

    private renderBarChart(data: any): string {
        const labels = data.labels || [];
        const papers = data.paper || data.values || [];
        if (!labels.length) return '';

        const hasTypes = data.paper && (data.report || data.patent);
        const maxVal = Math.max(...papers, ...(data.report || []), ...(data.patent || []), 1);
        let bars = '';
        for (let i = 0; i < labels.length; i++) {
            const p = papers[i] || 0;
            const r = (data.report || [])[i] || 0;
            const pt = (data.patent || [])[i] || 0;
            const total = p + r + pt;
            const pct = Math.round((total / maxVal) * 100);
            if (hasTypes && total > 0) {
                const pPct = Math.round((p / total) * 100);
                const rPct = Math.round((r / total) * 100);
                const ptPct = 100 - pPct - rPct;
                bars += `<div class="chart-bar-item">
                    <div class="chart-bar-label">${labels[i]}</div>
                    <div class="chart-bar-track">
                        <div class="chart-bar-stacked" style="width:${pct}%;display:flex;height:100%;border-radius:4px;overflow:hidden">
                            ${p > 0 ? `<div style="width:${pPct}%;background:#3B82F6;height:100%"></div>` : ''}
                            ${r > 0 ? `<div style="width:${rPct}%;background:#22C55E;height:100%"></div>` : ''}
                            ${pt > 0 ? `<div style="width:${ptPct}%;background:#F59E0B;height:100%"></div>` : ''}
                        </div>
                    </div>
                    <div class="chart-bar-value">${total}</div>
                </div>`;
            } else {
                bars += `<div class="chart-bar-item">
                    <div class="chart-bar-label">${labels[i]}</div>
                    <div class="chart-bar-track">
                        <div class="chart-bar-fill" style="width:${pct}%"></div>
                    </div>
                    <div class="chart-bar-value">${total}</div>
                </div>`;
            }
        }
        return `<div class="inline-chart bar-chart">${bars}</div>`;
    }

    private renderDonutChart(data: any): string {
        const entries = Object.entries(data);
        if (!entries.length) return '';
        const total = entries.reduce((sum, [, v]) => sum + (v as number), 0);
        if (!total) return '';

        const colors = ['#3B82F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6'];
        let items = '';
        entries.forEach(([key, val], i) => {
            const pct = Math.round(((val as number) / total) * 100);
            const color = colors[i % colors.length];
            items += `<div class="donut-item">
                <span class="donut-dot" style="background:${color}"></span>
                <span class="donut-label">${key}</span>
                <span class="donut-value">${val}건 (${pct}%)</span>
            </div>`;
        });
        return `<div class="inline-chart donut-chart">${items}</div>`;
    }

    private slimAgentResearchers(researchers: any[]): any[] {
        return (researchers || []).slice(0, 10).map((row: any) => ({
            researcher_id: row.researcher_id || row.id || '',
            name: row.name || row.name_kor || row.name_eng || '',
            org: row.org || row.org_name || '',
            paper_cnt: row.paper_cnt || 0,
            report_cnt: row.report_cnt || 0,
            patent_cnt: row.patent_cnt || 0,
            keyword: row.keyword || row.keyword_kor || '',
            matched_keywords: row.matched_keywords || [],
            keyword_match_count: row.keyword_match_count || 0,
            keyword_pub_count: row.keyword_pub_count || 0,
            direct_keyword_pub_count: row.direct_keyword_pub_count || 0,
            keyword_publication_score: row.keyword_publication_score || 0,
            score: row.score || 0,
            keyword_weight: row.keyword_weight || row.score_bonus || 0,
            weighted_score: row.weighted_score || 0,
            base_weighted_score: row.base_weighted_score || 0,
            weights_applied: row.weights_applied || {},
            score_components: row.score_components || {},
            normalized_score_components: row.normalized_score_components || {},
            score_breakdown: row.score_breakdown || {},
            score_evidence: row.score_evidence || '',
            hhi: row.hhi || 0,
            researcher_type: row.researcher_type || '',
            recent_pub_count: row.recent_pub_count || 0,
            recent_ratio: row.recent_ratio || 0,
            first_author_count: row.first_author_count || 0,
            corresponding_count: row.corresponding_count || 0,
            journal_level_count: row.journal_level_count || 0,
            journal_level_labels: row.journal_level_labels || [],
            similarity_score: row.similarity_score || 0,
            coauthor_paper_count: row.coauthor_paper_count || 0,
            shared_keywords: row.shared_keywords || [],
        }));
    }

    private persistAgentResultContext(summary: string, researchers: any[], query: string = '') {
        try {
            if (summary) {
                sessionStorage.setItem(Component.AGENT_SUMMARY_KEY, summary);
            }
            if (Array.isArray(researchers) && researchers.length > 0) {
                sessionStorage.setItem(
                    Component.AGENT_RESEARCHERS_KEY,
                    JSON.stringify(this.slimAgentResearchers(researchers))
                );
            }
            if (query) {
                sessionStorage.setItem(Component.AGENT_QUERY_KEY, query);
            }
        } catch { }
    }

    private readSessionStorageString(key: string): string {
        try {
            return (sessionStorage.getItem(key) || '').trim();
        } catch {
            return '';
        }
    }

    private getStoredAgentQuery(): string {
        return this.readSessionStorageString(Component.AGENT_QUERY_KEY);
    }

    private getStoredAgentSummary(): string {
        return this.readSessionStorageString(Component.AGENT_SUMMARY_KEY);
    }

    private getStoredAgentResearchers(): any[] {
        const raw = this.readSessionStorageString(Component.AGENT_RESEARCHERS_KEY);
        if (!raw) return [];
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    // === SSE 스트리밍 전송 ===
    public async send(messageOverride: string = '', displayOverride: string = '') {
        const msg = (messageOverride || this.input).trim();
        const visibleMsg = (displayOverride || msg).trim();
        if (!msg || this.loading) return;

        this.updatePageContext();

        this.messages.push({ role: 'user', content: visibleMsg || msg });
        this.input = '';
        this.loading = true;
        this.generationStopRequested = false;

        // 히스토리 이벤트 전달
        let researcherContext: any = null;
        if (this.currentPageContext.type === 'researcher' && this.currentPageContext.researcher_id) {
            try {
                const res = await wiz.call("researcher_info", { researcher_id: this.currentPageContext.researcher_id });
                if (res.code === 200 && res.data) {
                    researcherContext = res.data;
                }
            } catch {}
        }
        const historyDetail: any = {
            question: visibleMsg || msg,
            timestamp: Date.now(),
            pageContext: { ...this.currentPageContext },
            pageLabel: this.currentPageLabel,
            prompt: msg,
        };
        if (researcherContext) historyDetail.researcherContext = researcherContext;
        window.dispatchEvent(new CustomEvent('chatbot-history-add', {
            detail: historyDetail
        }));
        this.saveHistory(historyDetail.question, historyDetail.timestamp, historyDetail.pageContext, historyDetail.pageLabel, researcherContext);

        await this.service.render();
        this.scrollToBottom();

        const historyPayload = this.messages
            .filter((m: any) => m.role === 'user' || m.role === 'assistant')
            .map((m: any) => ({ role: m.role, content: m.content || '' }));

        // SSE 스트리밍 호출
        const assistantMsg: any = {
            role: 'assistant',
            content: '',
            html: null as SafeHtml | null,
            researchers: [],
            researcher_info: [],
            streaming: true,
            intent: null as any,
            keywords: [] as string[],
            steps: [] as any[],
            stepsOpen: false,
            hasVisualization: false,
            resultIds: [] as string[],
            recommendation_summary: '',
            followUpQuestions: [] as string[],
            followups: [] as string[],
            progress: this.createProgressState(),
            requestMessage: msg,
        };
        this.messages.push(assistantMsg);

        const abortController = new AbortController();
        this.activeAbortController = abortController;
        this.activeAssistantMsg = assistantMsg;

        if (this.generationStopRequested) {
            this.markGenerationCancelled(assistantMsg);
            this.loading = false;
            this.clearActiveGeneration(abortController);
            await this.service.render();
            return;
        }

        try {
            const formData = new FormData();
            formData.append('message', msg);
            formData.append('history', JSON.stringify(historyPayload));
            formData.append('weights', JSON.stringify(this.getActiveWeights()));
            formData.append('current_page', JSON.stringify(this.currentPageContext));

            const response = await fetch(wiz.url('chat'), {
                method: 'POST',
                body: formData,
                signal: abortController.signal,
            });

            if (!response.ok) {
                assistantMsg.content = '오류가 발생했습니다.';
                assistantMsg.html = this.renderMarkdown(assistantMsg.content);
                assistantMsg.streaming = false;
                this.syncProgressState(assistantMsg, {
                    phase: 'error',
                    stage: '응답 시작 실패',
                    detail: '답변 스트림을 열지 못했습니다.',
                    currentStep: ''
                });
                this.loading = false;
                this.clearActiveGeneration(abortController);
                await this.service.render();
                return;
            }

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let streamComplete = false;

            while (true) {
                if (abortController.signal.aborted || streamComplete) break;
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            await this.handleSSEEvent(event, assistantMsg);
                            if (event?.type === 'done') {
                                streamComplete = true;
                                break;
                            }
                        } catch { }
                    }
                }
                if (streamComplete) break;
            }

            // 처리 잔여 버퍼
            if (!streamComplete && buffer.startsWith('data: ')) {
                try {
                    const event = JSON.parse(buffer.slice(6));
                    await this.handleSSEEvent(event, assistantMsg);
                    if (event?.type === 'done') {
                        streamComplete = true;
                    }
                } catch { }
            }

            if (streamComplete && !abortController.signal.aborted) {
                try { reader.cancel().catch(() => {}); } catch { }
            }

        } catch (e: any) {
            const aborted = this.isAbortError(e) || abortController.signal.aborted || this.generationStopRequested;
            if (aborted) {
                this.markGenerationCancelled(assistantMsg);
            } else {
                assistantMsg.content = assistantMsg.content || '네트워크 오류가 발생했습니다.';
                assistantMsg.html = this.renderMarkdown(assistantMsg.content);
                this.syncProgressState(assistantMsg, {
                    phase: 'error',
                    stage: '네트워크 오류',
                    detail: assistantMsg.content,
                    currentStep: ''
                });
            }
        }

        const cancelled = assistantMsg.progress?.phase === 'cancelled';
        const hasError = assistantMsg.progress?.phase === 'error';
        if (!hasError && !cancelled) {
            this.syncProgressState(assistantMsg, {
                phase: 'done',
                stage: '응답 완료',
                detail: assistantMsg.hasVisualization
                    ? '답변과 시각화 생성이 모두 완료되었습니다.'
                    : '답변 생성이 완료되었습니다.',
                currentStep: ''
            });
        }

        assistantMsg.streaming = false;
        assistantMsg.html = this.renderMarkdown(assistantMsg.content);
        if (!cancelled && !hasError) this.emitVisualizationTabSummary(assistantMsg);

        this.loading = false;
        this.clearActiveGeneration(abortController);

        // 연구자 검색 결과 → 이벤트 전달 (layout이 자동 이동 처리)
        if (!cancelled && !hasError && assistantMsg.researchers && assistantMsg.researchers.length > 0) {
            const ids = assistantMsg.researchers.map((r: any) => r.researcher_id || r.id).filter(Boolean);
            if (ids.length > 0) {
                window.dispatchEvent(new CustomEvent('chatbot-agent-results', { detail: { ids } }));
            }
        }

        // 연도 범위 파싱 → 연구자 프로필 페이지 연도 필터에 반영
        const yearRange = this.parseYearRange(msg);
        if (!cancelled && !hasError && yearRange) {
            window.dispatchEvent(new CustomEvent('chatbot-year-filter', {
                detail: yearRange
            }));
        }

        await this.service.render();
        this.scrollToBottom();
        this.clearPersistedChatState();
    }

    private isAbortError(error: any): boolean {
        return error?.name === 'AbortError' || error?.code === 20;
    }

    private chatbotModelProblemNotice(): string {
        return 'AI 모델 응답에 문제가 있어 답변을 생성하지 못했습니다. 잠시 후 다시 시도하거나 관리자에게 모델 상태를 확인해 주세요.';
    }

    private isModelProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        return [
            'model',
            'llm',
            'ollama',
            'api/chat',
            'not found',
            'notfound',
            'timeout',
            'timed out',
            'connection',
            'refused',
            'unavailable',
            '모델'
        ].some((marker: string) => text.includes(marker));
    }

    private chatbotErrorMessage(event: any): string {
        const rawMessage = String(event?.message || '').trim();
        if (event?.model_error === true || this.isModelProblemMessage(rawMessage)) {
            return this.chatbotModelProblemNotice();
        }
        return rawMessage || '오류가 발생했습니다.';
    }

    private clearActiveGeneration(abortController?: AbortController) {
        if (!abortController || this.activeAbortController === abortController) {
            this.activeAbortController = null;
            this.activeAssistantMsg = null;
            this.generationStopRequested = false;
        }
    }

    private markGenerationCancelled(msg: any) {
        const notice = '답변 생성을 중단했습니다.';
        if (!msg.content) {
            msg.content = notice;
        } else if (!msg.content.includes(notice)) {
            msg.content = `${msg.content.trim()}\n\n${notice}`;
        }
        msg.streaming = false;
        msg.html = this.renderMarkdown(msg.content);
        this.syncProgressState(msg, {
            phase: 'cancelled',
            stage: '생성 중단',
            detail: '사용자 요청으로 답변 생성을 중단했습니다.',
            currentStep: ''
        });
    }

    public async stopGeneration() {
        if (!this.loading && !this.activeAbortController) return;

        this.generationStopRequested = true;
        if (this.activeAbortController) this.activeAbortController.abort();

        if (this.activeAssistantMsg) {
            this.markGenerationCancelled(this.activeAssistantMsg);
        }

        this.loading = false;
        await this.service.render();
        this.scrollToBottom();
    }

    private createProgressState() {
        return {
            phase: 'queued',
            stage: '요청 접수',
            detail: '질문을 정리하고 실행 흐름을 선택하고 있습니다.',
            currentStep: '',
            completedSteps: 0,
            totalSteps: 0,
            percent: 6,
            contentChunks: 0,
        };
    }

    private resolveToolProgressMeta(name: string, fallbackLabel: string) {
        const metaMap: any = {
            intent_analysis: { phase: 'routing', stage: '의도 분석' },
            tool_planning: { phase: 'routing', stage: '분석 계획 수립' },
            keyword_expand: { phase: 'keywords', stage: '검색 키워드 확장' },
            draft_response: { phase: 'drafting', stage: '답변 초안 생성' },
            review_response: { phase: 'reviewing', stage: '답변 검토' },
            visualization: { phase: 'visualizing', stage: '시각화 결과 정리' },
        };
        return metaMap[name] || { phase: 'collecting', stage: fallbackLabel || '근거 수집' };
    }

    private syncProgressState(msg: any, patch: any = {}) {
        const progress = {
            ...(msg.progress || this.createProgressState()),
            ...patch,
        };

        const steps = Array.isArray(msg.steps) ? msg.steps : [];
        progress.completedSteps = steps.filter((step: any) => step.status === 'done').length;
        progress.totalSteps = steps.length;

        if (!progress.currentStep) {
            for (let i = steps.length - 1; i >= 0; i--) {
                if (steps[i].status === 'active') {
                    progress.currentStep = steps[i].text || '';
                    break;
                }
            }
        }

        progress.percent = this.estimateProgressPercent(msg, progress);
        msg.progress = progress;
    }

    private estimateProgressPercent(msg: any, progress: any): number {
        if (progress.phase === 'done' || progress.phase === 'error' || progress.phase === 'cancelled') return 100;

        const stepsTotal = Math.max(progress.totalSteps || 0, 1);
        const stepRatio = (progress.completedSteps || 0) / stepsTotal;
        const baseMap: any = {
            queued: 6,
            routing: 16,
            keywords: 26,
            collecting: 34,
            drafting: 70,
            reviewing: 84,
            streaming: 90,
            visualizing: 96,
        };

        let percent = baseMap[progress.phase] || 20;

        if (progress.phase === 'collecting') {
            percent = Math.max(percent, Math.min(76, 34 + Math.round(stepRatio * 42)));
        } else if (progress.phase === 'drafting') {
            percent = Math.max(percent, Math.min(82, 70 + Math.round(stepRatio * 12)));
        } else if (progress.phase === 'reviewing') {
            percent = Math.max(percent, Math.min(89, 84 + Math.round(stepRatio * 5)));
        } else if (progress.phase === 'streaming') {
            percent = Math.max(percent, Math.min(98, 90 + Math.min(progress.contentChunks || 0, 8)));
        }

        if (msg.hasVisualization && progress.phase !== 'done') {
            percent = Math.max(percent, 96);
        }

        return percent;
    }

    public getProgressSentence(msg: any): string {
        const progress = msg?.progress || {};
        const detail = progress.detail || '';
        const currentStep = progress.currentStep || '';

        if (progress.phase === 'error') {
            return detail || '답변 생성 중 오류가 발생했습니다.';
        }

        if (progress.phase === 'cancelled') {
            return detail || '답변 생성을 중단했습니다.';
        }

        if (progress.phase === 'done') {
            return detail || '답변 생성이 완료되었습니다.';
        }

        if (detail) {
            return detail;
        }

        if (currentStep) {
            return `${currentStep}을 진행하고 있습니다.`;
        }

        return `${progress.stage || '답변 생성'} 중입니다.`;
    }

    private createResultId(): string {
        const timestamp = Date.now();
        const counter = this.visualizationCounter++;
        return `viz-${timestamp}-${counter}`;
    }

    private summarizeChatForResultTab(msg: any): string {
        const sources = [
            msg?.recommendation_summary || '',
            msg?.content || ''
        ];

        for (const source of sources) {
            const cleaned = this.cleanChatSummarySource(source);
            if (cleaned) return this.shortenTabLabel(cleaned);
        }

        if (msg?.intent?.label) return `${msg.intent.label} 결과`;
        return '시각화 결과';
    }

    private cleanChatSummarySource(source: string): string {
        if (!source) return '';

        const withoutCode = source
            .replace(/```[\s\S]*?```/g, ' ')
            .replace(/<!--[\s\S]*?-->/g, ' ')
            .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
            .replace(/https?:\/\/\S+/g, ' ')
            .replace(/[#>*_`|]/g, ' ');

        const lines = withoutCode
            .split(/\n+/)
            .map(line => line.replace(/^[-+*\d.)\s]+/, '').trim())
            .filter(line =>
                line.length >= 4
                && !/^표\s*\d+/i.test(line)
                && !/^(추천\s*(요약|전문가|결과)|요약|결과|근거|후속\s*질문)\s*:?$/.test(line)
            );

        const sourceLine = lines[0] || withoutCode.replace(/\s+/g, ' ').trim();
        return sourceLine.split(/[.!?。？！]/)[0]?.trim() || sourceLine;
    }

    private shortenTabLabel(source: string): string {
        const normalized = source.replace(/\s+/g, ' ').trim();
        const limit = 34;
        if (normalized.length <= limit) return normalized;

        const words = normalized.split(' ');
        let summary = '';
        for (const word of words) {
            const next = summary ? `${summary} ${word}` : word;
            if (next.length > limit) break;
            summary = next;
        }

        if (!summary) summary = normalized.slice(0, limit);
        return `${summary}...`;
    }

    private emitVisualizationTabSummary(msg: any) {
        if (!msg?.resultIds || msg.resultIds.length === 0) return;
        const summary = this.summarizeChatForResultTab(msg);
        for (const resultId of msg.resultIds) {
            window.dispatchEvent(new CustomEvent('chatbot-generated-result-update', {
                detail: { resultId, summary }
            }));
        }
    }

    private async handleSSEEvent(event: any, assistantMsg: any) {
        const type = event.type;

        if (assistantMsg.progress?.phase === 'error' && type !== 'error') {
            if (type === 'done') {
                assistantMsg.streaming = false;
                await this.service.render();
            }
            return;
        }

        if (type === 'intent') {
            assistantMsg.intent = { skill: event.skill, label: event.label };
            this.syncProgressState(assistantMsg, {
                phase: 'routing',
                stage: '실행 흐름 결정',
                detail: `${event.label || '에이전트'} 경로로 진행합니다.`,
                currentStep: ''
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'keywords') {
            assistantMsg.keywords = event.keywords || [];
            this.syncProgressState(assistantMsg, {
                phase: 'keywords',
                stage: '검색 키워드 정리',
                detail: assistantMsg.keywords.length > 0
                    ? `확장 키워드 ${assistantMsg.keywords.length}개를 준비했습니다.`
                    : '키워드를 정리하고 있습니다.',
                currentStep: ''
            });
            await this.service.render();

        } else if (type === 'tool_start') {
            assistantMsg.steps.push({
                text: event.label || event.name,
                status: 'active'
            });
            const meta = this.resolveToolProgressMeta(event.name, event.label || event.name);
            this.syncProgressState(assistantMsg, {
                phase: meta.phase,
                stage: meta.stage,
                detail: `${event.label || event.name}을 진행하고 있습니다.`,
                currentStep: event.label || event.name
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'tool_result') {
            const steps = assistantMsg.steps;
            for (let i = steps.length - 1; i >= 0; i--) {
                if (steps[i].status === 'active') {
                    steps[i].status = event.ok ? 'done' : 'error';
                    steps[i].summary = event.summary;
                    break;
                }
            }
            const meta = this.resolveToolProgressMeta(event.name, event.label || event.name);
            this.syncProgressState(assistantMsg, {
                phase: meta.phase,
                stage: meta.stage,
                detail: event.summary || `${event.label || event.name} 처리를 마쳤습니다.`,
                currentStep: ''
            });
            await this.service.render();

        } else if (type === 'content') {
            assistantMsg.content += event.text || '';
            assistantMsg.html = this.renderMarkdown(assistantMsg.content);
            this.syncProgressState(assistantMsg, {
                phase: 'streaming',
                stage: '최종 답변 생성',
                detail: '생성한 답변을 실시간으로 전송하고 있습니다.',
                currentStep: '답변 본문 스트리밍',
                contentChunks: (assistantMsg.progress?.contentChunks || 0) + 1,
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'researchers') {
            const researchers = event.researchers || [];
            assistantMsg.researchers = researchers;
            assistantMsg.researcher_info = researchers.map((r: any) => ({
                id: r.researcher_id || r.id || '',
                name: r.name || r.name_kor || '',
                org: r.org || r.org_name || '',
            }));
            this.persistAgentResultContext(assistantMsg.recommendation_summary, researchers, assistantMsg.requestMessage || '');
            // 메시지 레벨 상태 업데이트
            const ids = researchers.map((r: any) => r.researcher_id || r.id).filter(Boolean);
            this.syncProgressState(assistantMsg, {
                phase: 'collecting',
                stage: '연관 연구자 정리',
                detail: ids.length > 0
                    ? `관련 연구자 ${ids.length}명을 답변에 연결했습니다.`
                    : '관련 연구자 정보를 정리했습니다.',
                currentStep: ''
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'recommendation_summary') {
            assistantMsg.recommendation_summary = event.summary || '';
            this.persistAgentResultContext(assistantMsg.recommendation_summary, assistantMsg.researchers, assistantMsg.requestMessage || '');
            this.emitVisualizationTabSummary(assistantMsg);
            this.syncProgressState(assistantMsg, {
                phase: 'streaming',
                stage: '추천 요약 정리',
                detail: '추천 사유 요약을 정리하고 있습니다.',
                currentStep: ''
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'html_block') {
            const html = event.html || '';
            if (html) {
                // 세션 레벨 시각화 플래그 설정
                this.hasVisualization = true;
                assistantMsg.hasVisualization = true;
                const resultId = this.createResultId();
                assistantMsg.resultIds.push(resultId);
                // 생성결과 탭으로 전달 (채팅창에는 표시하지 않음)
                window.dispatchEvent(new CustomEvent('chatbot-generated-result', {
                    detail: {
                        html,
                        timestamp: Date.now(),
                        resultId,
                        summary: this.summarizeChatForResultTab(assistantMsg),
                        title: event.title || ''
                    }
                }));
            }
            this.persistAgentResultContext(assistantMsg.recommendation_summary, assistantMsg.researchers, assistantMsg.requestMessage || '');
            this.syncProgressState(assistantMsg, {
                phase: 'visualizing',
                stage: '시각화 결과 정리',
                detail: html ? '답변과 함께 보여줄 시각화 자료를 생성했습니다.' : '시각화 자료를 준비하고 있습니다.',
                currentStep: ''
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'question') {
            assistantMsg.followUpQuestions = event.questions || [];
            assistantMsg.followups = assistantMsg.followUpQuestions;
            this.syncProgressState(assistantMsg, {
                phase: 'done',
                stage: '후속 질문 준비',
                detail: '다음 탐색에 바로 사용할 질문을 정리했습니다.',
                currentStep: ''
            });
            await this.service.render();
            this.scrollToBottom();

        } else if (type === 'error') {
            const errorMessage = this.chatbotErrorMessage(event);
            assistantMsg.content += `\n\n⚠️ ${errorMessage}`;
            assistantMsg.html = this.renderMarkdown(assistantMsg.content);
            this.syncProgressState(assistantMsg, {
                phase: 'error',
                stage: '오류 발생',
                detail: errorMessage,
                currentStep: ''
            });
            await this.service.render();

        } else if (type === 'done') {
            this.syncProgressState(assistantMsg, {
                phase: 'done',
                stage: '응답 완료',
                detail: assistantMsg.hasVisualization
                    ? '답변과 시각화 생성이 모두 완료되었습니다.'
                    : '답변 생성이 완료되었습니다.',
                currentStep: ''
            });
            this.emitVisualizationTabSummary(assistantMsg);
        }
    }

    private parseYearRange(text: string): { yearFrom: number, yearTo: number } | null {
        const patterns = [
            /(\d{4})\s*년?\s*(?:부터|이후|에서)\s*(\d{4})\s*년?\s*(?:까지|이전|사이)/,
            /(\d{4})\s*[~\-–—]\s*(\d{4})/,
        ];
        for (const pattern of patterns) {
            const match = text.match(pattern);
            if (match) {
                const y1 = parseInt(match[1]);
                const y2 = parseInt(match[2]);
                if (y1 >= 1900 && y1 <= 2100 && y2 >= 1900 && y2 <= 2100) {
                    return { yearFrom: Math.min(y1, y2), yearTo: Math.max(y1, y2) };
                }
            }
        }
        const startOnly = text.match(/(\d{4})\s*년?\s*(?:부터|이후)/);
        if (startOnly) {
            const y = parseInt(startOnly[1]);
            if (y >= 1900 && y <= 2100) return { yearFrom: y, yearTo: 0 };
        }
        const endOnly = text.match(/(\d{4})\s*년?\s*(?:까지|이전)/);
        if (endOnly) {
            const y = parseInt(endOnly[1]);
            if (y >= 1900 && y <= 2100) return { yearFrom: 0, yearTo: y };
        }
        return null;
    }

    private scrollToBottom() {
        setTimeout(() => {
            const el = document.getElementById('chatbot-messages');
            if (el) el.scrollTop = el.scrollHeight;
        }, 50);
    }

    public goToSearchList(msg: any) {
        const ids = (msg.researchers || []).map((r: any) => r.researcher_id || r.id).filter(Boolean);
        if (ids.length > 0) {
            const idsParam = ids.join(',');
            this.persistAgentResultContext(msg.recommendation_summary, msg.researchers || [], msg.requestMessage || '');
            window.dispatchEvent(new CustomEvent('chatbot-switch-tab', { detail: { tab: 'page' } }));
            this.router.navigate(['/search'], { queryParams: { tab: 'researcher', agent_ids: idsParam } });
        }
    }

    public async onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            if (event.isComposing || (event as any).keyCode === 229) return;
            event.preventDefault();
            event.stopPropagation();
            await this.submitInput();
        }
    }

    public canSend(): boolean {
        return !this.loading && Boolean((this.input || '').trim());
    }

    public async submitInput() {
        if (!this.canSend()) return;
        await this.send();
    }

    public goResearcher(id: string) {
        this.router.navigate(['/researcher', id]);
    }

    public async toggleSteps(msg: any) {
        msg.stepsOpen = !msg.stepsOpen;
        await this.service.render();
    }

    public isVisualizationGenerating(msg: any): boolean {
        if (!msg.steps) return false;
        return msg.steps.some((s: any) => s.status === 'active' && (s.text || '').includes('시각화'));
    }

    public async openClearConfirm() {
        if (this.clearConfirmBusy) return;
        this.clearConfirmOpen = true;
        await this.service.render();
    }

    public async closeClearConfirm() {
        if (this.clearConfirmBusy) return;
        this.clearConfirmOpen = false;
        await this.service.render();
    }

    public async clearChat() {
        if (this.clearConfirmBusy) return;

        this.clearConfirmBusy = true;
        await this.service.render();

        try {
            this.messages = [];
            this.hasVisualization = false;
            this.visualizationCounter = 0;
            this.currentSessionId = '';
            this.loadSuggestions();
            this.clearPersistedChatState();
            try {
                sessionStorage.removeItem(Component.AGENT_SUMMARY_KEY);
                sessionStorage.removeItem(Component.AGENT_RESEARCHERS_KEY);
                sessionStorage.removeItem(Component.AGENT_QUERY_KEY);
            } catch { }
            // DB 전체 세션 삭제
            try {
                await fetch('/wiz/api/portal.chatbot.component.chatbot/delete_all_sessions', { method: 'POST' });
            } catch {}
            window.dispatchEvent(new CustomEvent('chatbot-history-clear'));
            window.dispatchEvent(new CustomEvent('chatbot-clear-all'));
            // 레이아웃 세션 목록 새로고침
            window.dispatchEvent(new CustomEvent('chatbot-sessions-changed'));
        } finally {
            this.clearConfirmBusy = false;
            this.clearConfirmOpen = false;
            await this.service.render();
        }
    }

    public goToResults(msg: any) {
        const resultId = msg.resultIds?.length > 0 ? msg.resultIds[msg.resultIds.length - 1] : '';
        window.dispatchEvent(new CustomEvent('chatbot-switch-tab', {
            detail: { tab: 'results', resultId }
        }));
    }

    // === 예시 질문 ===
    private async loadSuggestions() {
        try {
            const pageType = this.getPageType();
            const { code, data } = await wiz.call('load_suggestions', {
                page_type: pageType,
                current_page: JSON.stringify(this.currentPageContext),
            });
            if (code === 200) {
                this.suggestions = data?.suggestions || [];
            } else {
                this.suggestions = [];
            }
        } catch {
            this.suggestions = [];
        }
        await this.service.render();
    }

    private getPageType(): string {
        const ctx = this.currentPageContext;
        if (ctx.type === 'search') return 'search';
        if (ctx.type === 'researcher') return 'researcher';
        return 'general';
    }

    public async sendSuggestion(suggestion: any) {
        const prompt = typeof suggestion === 'string'
            ? suggestion
            : suggestion.prompt || suggestion.text || '';
        const text = typeof suggestion === 'string' ? prompt : (suggestion.text || prompt);
        if (!prompt || this.loading) return;
        this.input = text;
        await this.service.render();
        await this.send(prompt, text);
    }

    public async sendFollowup(text: string) {
        if (!text || this.loading) return;
        this.input = text;
        await this.service.render();
        await this.send();
    }

    private async generateFollowups(userMsg: string, assistantMsg: any) {
        try {
            const { code, data } = await wiz.call('generate_followups', {
                last_user: userMsg,
                last_assistant: (assistantMsg.content || '').slice(0, 500),
            });
            if (code === 200 && data?.followups?.length > 0) {
                assistantMsg.followups = data.followups;
                await this.service.render();
                this.scrollToBottom();
            }
        } catch {}
    }

    private clearPersistedChatState() {
        try { localStorage.removeItem(Component.STORAGE_KEY); } catch {}
    }

    private saveHistory(question: string, timestamp: number, pageContext: any, pageLabel: string, researcherContext?: any) {
        // localStorage 히스토리는 더 이상 사용하지 않음 (DB 세션으로 대체)
    }

    // === DB 세션 관리 ===
    private debounceSaveSession() {
        if (this.saveTimer) clearTimeout(this.saveTimer);
    }

    private async saveSessionToDb() {
        return;
    }

    public async loadSessionFromDb(sessionId: string) {
        return;
    }

}

export default PortalChatbotComponentChatbotComponent;